import { DiscountSyncErrorToast } from "./DiscountSyncErrorToast";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { experienceKeys } from "@src/api/queryKeys";
import { EXPERIENCE_ROUTES } from "@src/routes/routes";
import { useQueryClient } from "@tanstack/react-query";

export function useDiscountSyncErrorToast() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const ref = useRef<"success" | "error">(undefined);

  return (status: "success" | "error") => {
    if (status === ref.current) {
      return;
    }
    ref.current = status;

    if (status === "error") {
      const onClick = () => {
        void navigate(EXPERIENCE_ROUTES.Experiences_Merchandising);
        toast.dismiss("DiscountSyncError");
      };
      toast.error(<DiscountSyncErrorToast onClick={onClick} />, {
        toastId: "DiscountSyncError",
        autoClose: 20000,
        closeOnClick: false,
      });
    } else {
      toast.info("Discount Synchronization Error Resolved");
    }

    void queryClient.invalidateQueries({
      queryKey: experienceKeys.homeOverviewPersonalizationList,
    });
  };
}
